module.exports = __webpack_public_path__ + "static/media/OSC.06e7dbb1.pdf";